import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form } from "react-final-form";
import Modal from "components/Modal/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import ModalFooterLeft from "components/Modal/ModalFooterLeft";
import ModalFooterRight from "components/Modal/ModalFooterRight";
import Button from "components/Button/Button";
import FruitFormFields, { validateFruitFormFields } from "./FruitFormFields";
import { saveFruit } from "./_actions";

const FruitModal = ({ viewModel, refData, saveFruit, close }) => {
    const onCancel = (dirty) => (e) => {
        if (!dirty) {
            close();
        } else if (window.confirm("Are you sure you want to close without saving?")) {
            close();
        }
    };

    const save = (viewModel) => {
        const fruit = {
            ...viewModel,
        };

        saveFruit(viewModel.farm.id, viewModel.budget.id, viewModel.block.id, fruit);
        close();
    };

    return (
        <Form initialValues={viewModel} validate={validateFruitFormFields} onSubmit={save}>
            {({ values, handleSubmit, pristine, submitting, dirty }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Modal title={`Fruit block: ${viewModel.block.name} (${viewModel.block.areaInHectares}ha)`} close={onCancel(dirty)} submitting={submitting} wide>
                            <ModalBody>
                                <FruitFormFields values={values} refData={refData} />
                            </ModalBody>
                            <ModalFooter>
                                <ModalFooterLeft>
                                    <Button id="fruit-cancel" onClick={onCancel(dirty)} secondary disabled={submitting}>
                                        Cancel
                                    </Button>
                                </ModalFooterLeft>
                                <ModalFooterRight>
                                    <Button id="fruit-save" submit primary disabled={pristine || submitting}>
                                        Save
                                    </Button>
                                </ModalFooterRight>
                            </ModalFooter>
                        </Modal>
                    </form>
                );
            }}
        </Form>
    );
};
export default compose(withAppContext, withActions({ saveFruit }))(FruitModal);
